<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>营销</el-breadcrumb-item>
        <el-breadcrumb-item>拼团</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-row>
            <el-col :span="2"><el-button type="primary" class="el-icon-circle-plus-outline"  size="small"  v-on:click="AddGroupBooking" >新增</el-button></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="名称" v-model="queryParam.title" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="商家" v-model="queryParam.businessName" size="small" clearable></el-input></el-col>
            <el-col :span="8" style="margin-left:5px">
              <el-date-picker
                v-model="queryParam.date"
                size="small" 
                type="daterange"
                align="right"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"                
                end-placeholder="结束日期"
                @change="dateSelect"
                >
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="margin-left:5px"><el-button type="primary" v-on:click="Search" size="small" >查询</el-button></el-col>
          </el-row>
      </el-form>
      <el-table :data="groupbookings" style="width: 100%">
        <el-table-column  prop="Title" :show-overflow-tooltip="true" fixed="left" label="名称"> </el-table-column>
        <el-table-column  prop="BusinessName" :show-overflow-tooltip="true"   label="所属商家"> </el-table-column>
        <el-table-column  prop="IndustryName"  label="行业"> </el-table-column>
        <el-table-column  prop="GroupPrice"  label="拼团价"> </el-table-column>
        <el-table-column  prop="SettlementAmount"  label="结算金额"> </el-table-column>
        <el-table-column  prop="NeedPeople"  label="拼团人数"> </el-table-column>
        <el-table-column  prop="SoldNumber"  label="已售数量" ></el-table-column>
        <el-table-column  prop="LimitNumber"  label="单人限购">
          <template slot-scope="scope">                    
            <p v-if="scope.row.LimitNumber==0">不限</p>
            <p v-else>{{scope.row.LimitNumber}}</p>         
          </template>
        </el-table-column>
        <el-table-column  prop="LimitTime"  label="拼团时间" ></el-table-column>
        <el-table-column  prop="BeginTime" width="120" label="开始时间" :formatter="dateFormat" ></el-table-column>
        <el-table-column  prop="EndTime" width="120" label="结束时间" :formatter="dateFormat"></el-table-column>
        <el-table-column  prop="PutOnShelves"  label="状态" > 
          <template slot-scope="scope">                    
            <p v-if="scope.row.PutOnShelves==true">上架</p>
            <p v-if="scope.row.PutOnShelves==false">下架</p>         
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="editGroupBooking(scope.row.Id)" type="text" size="small">
              编辑
            </el-button>
          <el-button  @click="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        groupbookings:[],
        queryParam:{          
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' CreateTime desc ',title:'',
          businessName:'',
          beginTime:'',
          endTime:'',
          date:''
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      AddGroupBooking:function(){
        this.$router.push({
          name:'groupBookingInfo',
          params:{
            Id:''
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/groupbooking/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.groupbookings = resp.data.groupbookings
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      editGroupBooking(id, rows){
        this.$router.push({
          name:'groupBookingInfo',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该拼团吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/groupbooking/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      },
      dateSelect(picker){
        if(picker==null){
          this.queryParam.beginTime = ''
          this.queryParam.endTime = ''
        }else{
          this.queryParam.beginTime = picker[0]
          this.queryParam.endTime = picker[1]
        }
      }

    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>